import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Auth() {
  const [params] = useSearchParams();
  const initial = (params.get("mode") === "register" || params.get("ref")) ? "register" : "login";
  const [mode, setMode] = useState(initial);
  const { user, login, register, error } = useAuth();
  const nav = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [referral, setReferral] = useState((params.get("ref") || "").toUpperCase());
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && typeof user === "object") nav("/lobby"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = mode === "login"
      ? await login(email, password)
      : await register(email, password, name || undefined, referral || undefined);
    setBusy(false);
    if (ok) {
      toast.success(mode === "login" ? "Welcome back" : (referral ? "Account created · 600 chips added (referral bonus applied)" : "Account created · 500 chips added"));
      nav("/lobby");
    }
  };

  return (
    <div className="vexis-ambient min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center" data-testid="auth-brand">
          <span className="chip-icon text-[22px]" />
          <span className="font-display text-xl tracking-tight">VEXIS</span>
        </Link>
        <div className="vexis-card p-6 sm:p-8">
          <div className="flex items-center justify-between mb-6">
            <h1 className="font-display text-2xl">{mode === "login" ? "Sign in" : "Create account"}</h1>
            <div className="flex text-xs">
              <button onClick={() => setMode("login")} className={`px-3 py-1.5 rounded-l-full border border-white/10 ${mode==="login" ? "bg-white/10 text-white" : "text-slate-400"}`} data-testid="auth-tab-login">Login</button>
              <button onClick={() => setMode("register")} className={`px-3 py-1.5 rounded-r-full border border-l-0 border-white/10 ${mode==="register" ? "bg-white/10 text-white" : "text-slate-400"}`} data-testid="auth-tab-register">Register</button>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            {mode === "register" && (
              <div>
                <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Display name</label>
                <input className="vexis mt-1" placeholder="Ada Lovelace" value={name} onChange={(e)=>setName(e.target.value)} data-testid="auth-name-input" />
              </div>
            )}
            <div>
              <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Email</label>
              <input type="email" required className="vexis mt-1" placeholder="you@vexis.io" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="auth-email-input" />
            </div>
            <div>
              <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Password</label>
              <input type="password" required minLength={6} className="vexis mt-1" placeholder="min 6 characters" value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="auth-password-input" />
            </div>
            {mode === "register" && (
              <div>
                <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Referral code <span className="text-slate-600">(optional)</span></label>
                <input className="vexis mt-1 tracking-widest uppercase" placeholder="e.g. VXAB12" value={referral} onChange={(e)=>setReferral(e.target.value.toUpperCase())} data-testid="auth-referral-input" />
                {referral && <div className="text-xs text-emerald-400 mt-1">+100 bonus chips on signup with a valid code</div>}
              </div>
            )}
            {error && <div className="text-sm text-red-400" data-testid="auth-error">{error}</div>}
            <button className="btn-gold w-full" disabled={busy} data-testid="auth-submit">
              {busy ? "Please wait…" : mode === "login" ? "Sign in" : `Create account · Claim ${referral ? 600 : 500} chips`}
            </button>
          </form>
        </div>
        <div className="text-center text-xs text-slate-500 mt-6">
          Skill · Precision · Stakes
        </div>
      </div>
    </div>
  );
}
